/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { TokenConfig } from '../../types/tokens';

/**
 * Calculates a "Trust Score" for a token configuration before deployment.
 * Returns 0-100.
 */
export const calculateTokenScore = (config: Partial<TokenConfig>): number => {
    let score = 50; // Base score

    // Metadata presence
    if (config.description && config.description.length > 20) score += 10;
    if (config.imageUrl) score += 10;
    if (config.headerImageUrl) score += 5;

    // Socials
    if (config.website) score += 5;
    if (config.twitter) score += 5;
    if (config.telegram) score += 5;

    // Security / Config
    if (config.chain === 'SOL') {
        if (config.tokenStandard === 'TOKEN_2022') {
            // Immutable?
            if (config.extensions?.immutable) score += 10;
            
            // Mint Revoked? (Fixed Supply is generally trusted more)
            if (config.extensions?.revokeMint) score += 10;
        } else {
            // Standard SPL
            score += 5; // Default trust
        }
    }

    return Math.min(Math.max(score, 0), 100);
};